import { motion, useAnimation } from 'framer-motion';
import { useEffect } from 'react';

import { useColorModeValue } from '@vimeo/bokeh';

export const SparkleIconMotion = ({
  isHovered,
  isMountWidthAnimationDone,
}: {
  isHovered: boolean;
  isMountWidthAnimationDone: boolean;
}) => {
  const smallStar = useAnimation();
  const largeStar = useAnimation();

  useEffect(() => {
    if (isMountWidthAnimationDone) {
      smallStar.start({
        rotate: -180,
      });

      largeStar.start({
        rotate: 180,
      });
    }
  }, [largeStar, smallStar, isMountWidthAnimationDone]);

  useEffect(() => {
    smallStar.start({
      rotate: isHovered ? -90 : 0,
    });

    largeStar.start({
      rotate: isHovered ? 90 : 0,
    });
  }, [isHovered, largeStar, smallStar]);

  const fillColor = useColorModeValue('black', 'white');

  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <motion.path
        d="M20.8611 4.11014L21.9028 4.47168L21.8992 4.47347C22.1068 4.54685 22.216 4.77237 22.1444 4.97819C22.1086 5.09095 22.0155 5.18402 21.8956 5.2234L20.8593 5.58493C20.4011 5.74423 20.0467 6.09861 19.8875 6.55679L19.5259 7.59846C19.4669 7.76312 19.3129 7.86514 19.1501 7.86514C19.1053 7.86514 19.0606 7.85798 19.0176 7.84187C18.9084 7.80786 18.8118 7.71121 18.7742 7.5913L18.4144 6.55501C18.2552 6.09682 17.9008 5.74244 17.4426 5.58314L16.4009 5.22161C16.3114 5.19476 16.2255 5.12138 16.1772 5.02652C16.1289 4.92987 16.1217 4.81711 16.1575 4.71688C16.1951 4.60233 16.2917 4.50569 16.4152 4.4681L17.4462 4.11014C17.9026 3.95085 18.2569 3.59647 18.4162 3.13828L18.7796 2.09662C18.81 2.00355 18.8834 1.91764 18.9782 1.8711C19.0731 1.82457 19.1859 1.81741 19.2861 1.8532C19.3953 1.88721 19.4901 1.98207 19.5295 2.10378L19.8892 3.13828C20.0485 3.59647 20.4029 3.95085 20.8611 4.11014Z"
        fill={fillColor}
        animate={smallStar}
        transition={{
          type: 'spring',
          stiffness: 500,
          damping: 60,
          mass: 1,
          delay: 0,
        }}
      />
      <motion.path
        d="M15.7316 10.906L18.3519 11.817L18.3536 11.8152C18.7349 11.9512 18.9353 12.3665 18.8047 12.7441C18.7349 12.9553 18.563 13.1254 18.3447 13.1969L15.7316 14.1062C14.5002 14.5339 13.5498 15.4843 13.1221 16.7139L12.2111 19.336C12.1019 19.6384 11.8191 19.8264 11.5202 19.8264C11.4432 19.8264 11.3663 19.8138 11.2893 19.7888C11.0656 19.7154 10.8956 19.5436 10.8275 19.3234L9.9219 16.7157C9.49414 15.4879 8.54376 14.5357 7.31417 14.108L4.69748 13.1987C4.51492 13.1379 4.36279 13.0054 4.27688 12.8336C4.19097 12.6618 4.17665 12.4578 4.23929 12.2752C4.31089 12.0568 4.48092 11.8868 4.69748 11.8152L7.31417 10.906C8.54376 10.4782 9.49414 9.52786 9.9219 8.29827L10.8329 5.67621C10.8866 5.50439 11.0226 5.34868 11.198 5.26098C11.3716 5.17507 11.5721 5.16254 11.7547 5.22339C11.9694 5.29499 12.1395 5.46323 12.2128 5.67979L13.1221 8.29827C13.5498 9.52786 14.5002 10.4782 15.7316 10.906Z"
        fill={fillColor}
        animate={largeStar}
        transition={{
          type: 'spring',
          stiffness: 500,
          damping: 60,
          mass: 1,
          delay: 0,
        }}
      />
    </svg>
  );
};
